// Accordion by WebSensePro.com
$(function () {
  $(".ad-show-more").click(function (e) {
    e.preventDefault();
    $(".ad-prod-desc").toggleClass("open");
    if ($(".ad-prod-desc.open")[0]) {
      $(".ad-show-more").html("[-] Show Less");
      $(".ad-show-more-div span").hide();
    } else {
      $(".ad-show-more-div span").show();
      $(".ad-show-more").html("[+] Show More");
    }
  });

  // (Optional) Active an item if it has the class "is-active"
  $(".accordion > .accordion-item.is-active")
    .children(".accordion-panel")
    .slideDown();
  $(".accordion > .accordion-item").click(function () {
    // Cancel the siblings
    $(this)
      .siblings(".accordion-item")
      .removeClass("is-active")
      .children(".accordion-panel")
      .slideUp();
    // Toggle the item
    $(this)
      .toggleClass("is-active")
      .children(".accordion-panel")
      .slideToggle("ease-out");
    $(this)
      .toggleClass("is-active")
      .children(".accordion-panel")
      .css("display", "flex");
  });

  $(".tp-list a").click(function (e) {
    e.preventDefault();
    var href = $(this).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(href).offset().top - 20,
      },
      "slow"
    );
  });

  $(".drawerButton").click(function (e) {
    $(".product-drawer").toggleClass("active");
    $(".product-drawer-overlay").toggle();
    $("body").toggleClass("overflow-hidden");
    $(".product-drawer > .line-top-style.drawerButton").toggle();
    e.preventDefault();
  });

  $(".product-drawer-overlay").click(function (e) {
    $(".product-drawer").removeClass("active");
    $("body").removeClass("overflow-hidden");
    $(".product-drawer > .line-top-style.drawerButton").hide();
    $(this).hide();
    e.preventDefault();
  });

  $("body").on("click", "._Button_10ofi_81", function () {
    alert("bla bla");
  });
});

$(document).ready(function () {
  /* function faq topics-index*/

  $(".collapse-trigger").on("click", function (e) {
    $(".topics-index").parent().toggleClass("collapsed");
  });
  /* end topics-index */

  function scrollToElement(id) {
    $(".topics-index").parent().removeClass("collapsed");
    var target = $("#" + id);
    if (target.length) {
      $("html, body").animate(
        {
          scrollTop: target.offset().top,
        },
        1000
      );
    } else {
      alert("target not found");
    }
  }
});

// Hide section id on browser url
$(document).ready(function() {
  $('a.header__menu-item[href^="#"]').click(function(event) {
    // Prevent default anchor click behavior
    event.preventDefault();

    // Get the target section ID from the href attribute
    var target = this.hash;
    var targetId = $(target);

    // Animate scroll to the target section
    if (targetId.length) {
      $('html, body').stop().animate({
        scrollTop: targetId.offset().top
      }, 900, 'swing', function() {
        // Animation complete
      });
    }
  });
});

$(document).ready(function() {
var acc = document.getElementsByClassName("accordion-dropdown");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      this.childNodes[1].childNodes[1].childNodes[1].classList.toggle("active");
      // console.log(this.childNodes[1].childNodes[1]);
      // document.getElementsByClassName("accordion-dropdown-arrow").classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
});